import React from 'react';

import { connect, useDispatch } from 'react-redux';
import classNames from 'classnames';

import MetisMenu from 'metismenujs';

import { getBlockReconRoutes } from 'service/appconfiguration/action';
import MenuItem from './MenuItem';
import MenuItemWithChildren from './MenuItemWithChildren';


const AppMenu = ({ menuItems }, ...props) => {

    const mode = props.mode;
    const theme = props.theme;


    const dispatch = useDispatch();

    const initAppMenu = () => {
        if (mode === 'horizontal') {
            const menuRef = new MetisMenu('#menu-bar').on('shown.metisMenu', (event) => {
                window.addEventListener('click', function menuClick(e) {
                    if (!event.target.contains(e.target)) {
                        menuRef.hide(event.detail.shownElement);
                        window.removeEventListener('click', menuClick);
                    }
                });
            });
        } else {
            new MetisMenu('#menu-bar').dispose();
            new MetisMenu('#menu-bar', {
                parentTrigger: 'li',
                subMenu: 'ul',
                toggle: true,
                triggerElement: 'a',
            });
        }
    };

    React.useEffect(() => {
        dispatch(getBlockReconRoutes());
    }, []);

    React.useEffect(() => {
        if (menuItems.length > 0) {
            new MetisMenu('#menu-bar').dispose();
            initAppMenu();
        }
    }, [menuItems]);

    const isHorizontal = mode === 'horizontal';


    return (
        <>
            {menuItems && (
                <ul className="metismenu" id="menu-bar">
                    {menuItems.map((item, i) => {
                        return (
                            <React.Fragment key={item.id}>
                                {item.header && !isHorizontal && (
                                    <li className="menu-title" key={`${item}-el`}>
                                        {item.header}
                                    </li>
                                )}

                                {/* 
                                {(item.view == sidebarStatus.sidebar)  && ( */}
                                <>
                                    {item.children ? (
                                        <MenuItemWithChildren
                                            item={item}
                                            isSourceExplorer={item.name === 'Source Explorer'}
                                            subMenuClassNames={theme ? 'nav-second-level-dark' : 'nav-second-level'}
                                            linkClassNames="side-nav-link"
                                        />
                                    ) : (
                                        <MenuItem
                                            item={item}
                                            className={classNames({ 'mm-active': false })}
                                            linkClassName="side-nav-link"
                                        />
                                    )}
                                </>
                                {/* )} */}


                            </React.Fragment>
                        );
                    })}
                </ul>
            )}
        </>
    );
};

AppMenu.defaultProps = {
    mode: 'horizontal',
};

const mapStateToProps = (state) => ({
    menuItems: state.appConfigurationReducer.menuItems,
});


export default connect(mapStateToProps)(React.memo(AppMenu));
